import styled from "styled-components";

export const TheSpan = styled.span`
background-color: #507900;
padding: 5px;
position: fixed;
bottom: 10px;
right: 10px;
border-radius: 5px;
cursor: pointer;

&:hover{
    // background-color: #bd152b;
    background-color: #607d8b7a;
}
`